export const isValidEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  
    if (!emailRegex.test(email)) {
      return false;
    }
  
    if (email.includes('+')) {
      return false;
    }

    if (email.includes('..')) {
        return false;
    }
  
    return true;
  };
  

 export const normalizeEmail = (email) => {
    const [localPart, domain] = email.toLowerCase().split('@');
  
    // Remove dots only if it's a gmail domain (optional if you want to match Gmail rules)
    if (domain === 'gmail.com' || domain === 'googlemail.com') {
      return `${localPart.replace(/\./g, '')}@${domain}`;
    }
  
    // For other domains, return as is
    return `${localPart}@${domain}`;
  };
  
  